import { addDataLayerEntry } from '@printdeal/data-layer-manager';

export const addDataLayerEntryOnLanguageSwitch = () => addDataLayerEntry('gaEvent', {
  gaEvent: {
    eventCategory: 'languageSwitch',
    eventAction: 'click',
    eventLabel: undefined,
    eventValue: undefined,
    eventNonInteraction: false,
  },
});

export const createUrl = (path: string) => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    return path + url.search;
  }
  return path;
};
